import * as Sentry from "@sentry/react-native";
import { Stack } from "expo-router/stack";
import { TailwindProvider } from "tailwind-rn";
import { PaperThemeProvider } from "ui";

import utilities from "../../tailwind.json";
import { initializeSentry } from "../services/sentry";

initializeSentry();

function Layout() {
  return (
    <TailwindProvider utilities={utilities}>
      <PaperThemeProvider>
        <Stack screenOptions={{ headerShown: false }} />
      </PaperThemeProvider>
    </TailwindProvider>
  );
}

export default Sentry.wrap(Layout);
